import React from 'react'
import { TableProps } from 'antd/lib/table'
import moment from 'moment'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { R8Data } from 'src/store/ducks/reports/types'
import { Table, Text, Tooltip } from 'src/components/Ant'

function abbreviate(word: string, index: number) {
  return index
    ? /[A-Z]/.test(word.charAt(0))
      ? `${word.charAt(0)}.`
      : /[0-9]/.test(word.charAt(0))
      ? word
      : null
    : word
}

const columns: ColumnProps<R8Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.8.data.request-number',
    width: 50
  },
  {
    align: 'center',
    dataIndex: 'requested_on',
    key: 'requested_on',
    render: (requested_on: number) => (
      <Text>{moment.unix(requested_on).format('DD/MM/YYYY')}</Text>
    ),
    title: 'web.report.9.data.created-on',
    width: 60
  },
  {
    align: 'center',
    dataIndex: 'e_ticket',
    key: 'e_ticket',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.data.e-ticket',
    width: 60
  },
  {
    align: 'center',
    dataIndex: 'traveler',
    ellipsis: true,
    key: 'traveler',
    render: (value: string) => (
      <Tooltip title={<>{value}</>}>
        <Text>{value.split(' ').map(abbreviate).join(' ')}</Text>
      </Tooltip>
    ),
    title: 'web.report.8.data.traveler'
  },
  {
    align: 'center',
    dataIndex: 'withdrawal_city',
    ellipsis: true,
    key: 'withdrawal_city',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.data.withdrawal-city'
  },
  {
    align: 'center',
    dataIndex: 'withdrawal_date',
    key: 'withdrawal_date',
    render: (value: number) => (
      <Text>{moment.unix(value).utc().format('DD/MM/YYYY HH:mm')}</Text>
    ),
    title: 'web.report.8.data.withdrawal-date'
  },
  {
    align: 'center',
    dataIndex: 'return_city',
    ellipsis: true,
    key: 'return_city',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.data.return-city'
  },
  {
    align: 'center',
    dataIndex: 'return_date',
    key: 'return_date',
    render: (value: number) => (
      <Text>{moment.unix(value).utc().format('DD/MM/YYYY HH:mm')}</Text>
    ),
    title: 'web.report.8.data.return-date',
    width: '50'
  },
  {
    align: 'center',
    dataIndex: 'company',
    ellipsis: true,
    key: 'company',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.data.company'
  },
  {
    align: 'center',
    dataIndex: 'supplier_name',
    ellipsis: true,
    key: 'supplier_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.8.data.agency-name'
  },
  {
    align: 'right',
    dataIndex: 'total_value',
    key: 'total_value',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.8.data.tickets-total-sum'
  }
]

function TableDetail(props: TableProps<R8Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
